var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9168 12.4413C15.6578 12.7055 15.5388 13.0875 15.5978 13.4623L16.4867 18.6409C16.5617 19.0798 16.3857 19.524 16.0368 19.7776C15.6948 20.0408 15.2399 20.0723 14.8669 19.8618L10.4385 17.4304C10.2845 17.3441 10.1136 17.2978 9.93858 17.2925H9.66761C9.57362 17.3073 9.48164 17.3388 9.39765 17.3873L4.96823 19.8303C4.74926 19.946 4.50129 19.9871 4.25832 19.946C3.6664 19.8281 3.27145 19.2345 3.36844 18.6082L4.25832 13.4296C4.31731 13.0518 4.19833 12.6676 3.93936 12.3992L0.328833 8.71521C0.0268723 8.40681 -0.078114 7.94368 0.059868 7.52581C0.19385 7.109 0.535806 6.80481 0.948752 6.73639L5.9181 5.97749C6.29605 5.93644 6.62801 5.69436 6.79799 5.33649L8.9877 0.610485C9.03969 0.505229 9.10669 0.408394 9.18768 0.326294L9.27766 0.252615C9.32466 0.197881 9.37865 0.152621 9.43864 0.115782L9.54763 0.0736793L9.71761 0H10.1386C10.5145 0.0410499 10.8455 0.277876 11.0184 0.631537L13.2371 5.33649C13.3971 5.68067 13.7081 5.9196 14.067 5.97749L19.0364 6.73639C19.4563 6.79955 19.8073 7.10479 19.9463 7.52581C20.0773 7.94789 19.9643 8.41102 19.6563 8.71521L15.9168 12.4413Z",
    fill: "#FFD131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStar);
export default __webpack_public_path__ + "static/media/RatingStar.8ee60b0f6cdabf61bbd23c10cb0d92b9.svg";
export { ForwardRef as ReactComponent };